import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export const CustomTooltip = withStyles((theme: any) => ({
  arrow: { color: theme.palette.brand.greenDark },
  tooltip: {
    backgroundColor: theme.palette.brand.greenDark,
    color: theme.palette.primary.light,
    marginBottom: 3,
    textAlign: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
}))(Tooltip);

export default CustomTooltip;
